import DynamicHeader from 'components/dynamic_header/DynamicHeader';
import TipoSolucoesEnum from 'enums/TipoSolucoesEnum';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import InPractice, { TypeCard } from 'pages/solucoes/components/generics/InPractice';
import HeaderSolution from 'pages/solucoes/components/newPageSolutionsComponents/HeaderSolution';
import NewFormSolucoes from 'pages/solucoes/components/newPageSolutionsComponents/NewFormSolucoes';
import NewInPractice from 'pages/solucoes/components/newPageSolutionsComponents/NewInPractice';
import NewOverview from 'pages/solucoes/components/newPageSolutionsComponents/NewOverview';
import NewSupportMaterial from 'pages/solucoes/components/newPageSolutionsComponents/NewSupportMaterial';
import React, { useEffect, useState } from 'react';

import gestaoBanner from '../../assets/gestaoNota10/gestaoBanner.jpg';
import imagem_inpratice_01 from '../../assets/gestaoNota10/inPratice/img_01.jpg';
import imagem_inpratice_02 from '../../assets/gestaoNota10/inPratice/img_02.jpg';
import imagem_inpratice_03 from '../../assets/gestaoNota10/inPratice/img_03.jpg';
import imagem_inpratice_04 from '../../assets/gestaoNota10/inPratice/img_04.jpg';
import imagem_inpratice_08 from '../../assets/gestaoNota10/inPratice/img_08.jpg';
import imagem_inpratice_09 from '../../assets/gestaoNota10/inPratice/img_09.jpg';
import imagem_inpratice_10 from '../../assets/gestaoNota10/inPratice/img_10.jpg';
import imagem_inpratice_11 from '../../assets/gestaoNota10/inPratice/img_11.jpg';
import imagem_inpratice_12 from '../../assets/gestaoNota10/inPratice/img_12.jpg';
import ImagemGestaoNota10 from '../../assets/gestaoNota10/logo.jpg';
import imagem_01 from '../../assets/gestaoNota10/material/imagem_01.png';
import GlobalStyled from '../../Solucoes.styled';
import arrow from './../../assets/arrow.svg';
import { validAccessExclusivo } from 'pages/solucoes/helpers/FunctionsHelpersSolucoes';
import useFetch from 'hooks/useFetch';
import ResgatedToken from 'pages/solucoes/components/solucoes/ResgatedToken';

const GestaoNota10 = () => {
    const [openModalToken, setOpenModalToken] = useState<boolean>(false);
    const [modalContentExclusive, setModalContentExclusive] = useState<boolean>(false);

    const [access, setAccess] = useState<boolean>(false);

    useFetch(async () => {
        const status = await validAccessExclusivo();
        setAccess(status);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <DynamicHeader />
            <HeaderSolution img={gestaoBanner} />
            <GlobalStyled.Container>
                <NewOverview
                    name={'GESTÃO'}
                    subname={'NOTA 10'}
                    dados={{
                        title: 'Gestão Nota 10',
                        descricao: `
                        Desde 2005, o Instituto Ayrton Senna leva para as redes de ensino, como política pública, o programa Gestão Nota 10, voltado para o fortalecimento das lideranças educacionais e escolares.
                        A partir de 2024, a solução recebe uma atualização para adequação e alinhamento à Base Nacional Comum Curricular – BNCC, mantendo a mesma essência.
                        
                        `,
                        objetivo: `
                        O objetivo principal do Gestão Nota 10 é promover o desenvolvimento de uma política educacional democrática e inclusiva a partir da construção de uma rede integrada de escolas autônomas, que garantam o ingresso, 
                        a permanência e o sucesso dos alunos, geridas por diretores tecnicamente competentes e capacitados a garantirem o alcance das metas de qualidade da aprendizagem dos alunos e melhoria dos indicadores educacionais.
                         `,
                        publicoAlvo: '1º ao 9º do Ensino Fundamental.',
                        avaliacao: 'Diagnóstico geral da rede de ensino.',
                        formacao: `
                                Encontros formativos para gestores escolares (carga horária – 36 horas).
                        `,
                        acompanhamento: `
                          Dados quantitativos e qualitativos, ancorados em indicadores e
                        metas previamente definidas.
                        `,
                        atores: `
                         Estudante, Professor (gestão da sala de aula: ensino/ aprendizagem); </br>
                        Coordenador Pedagógico / Diretor (gestão da rotina escolar); </br> Secretaria de Educação
                        (gestão da política educacional).
                        `,
                        elementos: `
                        <ol>
                            <li>1º - Adoção como política pública educacional, uma ferramenta
                            estruturadora da Secretaria de Educação e da unidade escolar;</li>
                            <li>2º - Recursos e/ou Infraestrutura, se utiliza da estrutura já existente na Secretaria de Educação e viabiliza
                            a articulação dos recursos já disponíveis para a educação;</li>
                            <li>3º - Formação dos
                            profissionais;</li>
                            <li>4º - Forma de acompanhamento e avaliação, quatro áreas estratégicas
                            da gestão: da aprendizagem, do ensino, da rotina escolar e da política educacional.</li>
                        </ol>                    
                        `,
                        img: ImagemGestaoNota10,
                        heightImg: '280px',
                    }}
                />

                <NewInPractice
                    items={[
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_01,
                            credits: {
                                credits: 'Inglidy Matos de Souza',
                                local: 'Boca do Acre',
                                ano: '2024',
                            },
                        },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_02,
                            credits: {
                                credits: 'Inglidy Matos de Souza',
                                local: 'Boca do Acre',
                                ano: '2024',
                            },
                        },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_03,
                            credits: {
                                credits: 'Inglidy Matos de Souza',
                                local: 'Boca do Acre',
                                ano: '2024',
                            },
                        },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_04,
                            credits: {
                                credits: 'Inglidy Matos de Souza',
                                local: 'Boca do Acre',
                                ano: '2024',
                            },
                        },
                        // {
                        //     type: TypeCard.IMAGEM,
                        //     url: imagem_inpratice_05,
                        //      credits: {
                        //          credits: 'Aurelio Alves',
                        //          local: 'Sobral',
                        //          ano: '2024',
                        //      },
                        // },
                        // {
                        //     type: TypeCard.IMAGEM,
                        //     url: imagem_inpratice_06,
                        //      credits: {
                        //          credits: 'Aurelio Alves',
                        //          local: 'Sobral',
                        //          ano: '2024',
                        //      },
                        // },
                        // {
                        //     type: TypeCard.IMAGEM,
                        //     url: imagem_inpratice_07,
                        //      credits: {
                        //          credits: 'Aurelio Alves',
                        //          local: 'Sobral',
                        //          ano: '2024',
                        //      },
                        // },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_09,
                            credits: {
                                credits: 'Miguel Castaño',
                                local: 'Ribeirão Pires',
                                ano: '2022',
                            },
                        },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_10,
                            credits: {
                                credits: 'Miguel Castaño',
                                local: 'Ribeirão Pires',
                                ano: '2022',
                            },
                        },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_08,
                            credits: {
                                credits: 'Diego Villamarin',
                                local: 'Ribeirão Pires',
                                ano: '2019',
                            },
                        },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_11,
                            credits: {
                                credits: 'Diego Villamarin',
                                local: 'Ribeirão Pires',
                                ano: '2019',
                            },
                        },
                        {
                            type: TypeCard.IMAGEM,
                            url: imagem_inpratice_12,
                            credits: {
                                credits: 'Diego Villamarin',
                                local: 'Ribeirão Pires',
                                ano: '2019',
                            },
                        },
                    ]}
                    description={`
                Quer conhecer um pouco mais sobre como o Gestão Nota 10 acontece na prática? <br/><br/>
                Navegue pelas imagens e vídeos e conheça algumas das redes onde a solução é implementada atualmente.<br/><br/>
                Sua rede pode ser a próxima a implementar a solução Gestão Nota 10 e ter as imagens compartilhadas aqui na humane. Que tal?<br/><br/>

                    `}
                    linkExclusivo="/exclusivo/gestao-nota-10"
                    openModalToken={() => setOpenModalToken(true)}
                />
                <NewSupportMaterial
                    description={
                        <>
                            A solução disponibiliza para as redes parceiras que implementam o Gestão Nota 10: <br />
                            <ul style={{ listStyle: `inside url(${arrow})` }}>
                                <li>
                                    <strong>Documento sobre a prática gestora no processo educacional</strong> para o fortalecimento de
                                    lideranças nas escolas e nas secretarias de educação;
                                </li>
                                <li>
                                    <strong>Sistemática de monitoramento e acompanhamento;</strong>
                                </li>
                                <li>
                                    <strong>Documentos para formação continuada</strong> nos temas: Educação Integral, Desenvolvimento da
                                    liderança na escola, O gestor e a política pública educacional com base em evidências, O diretor de escola
                                    como gestor de transformações e o olhar nas intervenções: o diretor e os acidentes de percurso.
                                </li>
                            </ul>
                        </>
                    }
                    img={imagem_01}
                />

                <NewFormSolucoes
                    tipoSolucao={TipoSolucoesEnum.GESTAO_NOTA_10}
                    preDefinition
                    linkExclusivo="/exclusivo/gestao-nota-10"
                    accessExclusivo={access}
                    setOpenModalToken={() => setOpenModalToken(true)}
                />
            </GlobalStyled.Container>
            <ResgatedToken
                valueModalToken={openModalToken}
                setHidenModalToken={setOpenModalToken}
                openModalSolucoesExclusiva={modalContentExclusive}
                setOpenModalSolucoesExclusiva={setModalContentExclusive}
            />
            <ContactContainer />
        </div>
    );
};

export default GestaoNota10;
